export const SET_ONBOARDING_STEP = 'SET_ONBOARDING_STEP';
export const SET_ONBOARDING_STATUS = 'SET_ONBOARDING_STATUS';
